import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { testInternetConnection } from "../../api/network";

import translationKeys from '../../translations/keys';
import { DEFAULT_BACKGROUND_GRADIENT, VL_BACKGROUND_GRADIENT } from "../../utils/colours";
import host from '../../utils/getHost';

import Heading from "../heading";
import { Flex } from "../layout";
import P from "../p";

const NetworkError = ({ tReady, t }) => {

    // Time in seconds until we test connection again
    const [timeUntilTest, setTimeUntilTest] = useState(30);

    // Runs every second
    useEffect(() => {
        if (timeUntilTest > 0) {
            // Decrement time after one second
            const timeout = setTimeout(() => setTimeUntilTest(s => s - 1), 1000);
            return () => clearTimeout(timeout);
        } else {
            // When time reaches 0, test connection
            const runTest = async () => {
                if (testInternetConnection()) {
                    // Success
                    // Reload page to restart app
                    window.location.reload();
                } else {
                    // Fail
                    // Restart timer
                    setTimeUntilTest(30);
                }
            }
            runTest();
        }
    }, [timeUntilTest]);

    return (
        <Flex column centre style={{ padding: 30, height: '100vh', background: /videoloft/.test(host) ? VL_BACKGROUND_GRADIENT : DEFAULT_BACKGROUND_GRADIENT }}>
            <Heading>{ tReady ? t(translationKeys.network.NETWORK_ERROR) : 'Network error'}</Heading>
            <P>
                {
                    timeUntilTest > 0 ? (
                        tReady ? t(translationKeys.network.TRYING_TO_RECONNECT_IN, { seconds: timeUntilTest }) : `Trying to reconnect you in ${timeUntilTest}s...`
                    ) : (
                        tReady ? t(translationKeys.network.TRYING_TO_RECONNECT) : 'Trying to reconnect you...'
                    )
                }
            </P>
        </Flex>
    );
}

export default withTranslation()(NetworkError);